import {Component, forwardRef, Input} from '@angular/core';
import {NG_VALUE_ACCESSOR, NG_VALIDATORS} from '@angular/forms';
import {AbstractFieldClass} from '../abstract-field.class';

declare const toastr: any;

@Component({
    selector: 'multiselect-field',
    templateUrl: 'multiselect-field.component.html',
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => MultiselectFieldComponent), multi: true },
        { provide: NG_VALIDATORS, useExisting: forwardRef(() => MultiselectFieldComponent), multi: true }
    ]
})
export class MultiselectFieldComponent extends AbstractFieldClass {
    @Input() title = '';
    @Input('value') _value: any = [];
    @Input('data') _data: any = [];
    @Input('accessError') _accessError: any = 'You do not have access to change amenity in the following buildings: ';
    @Input('blankError') _blankError: any = 'Building should not be blank.';
    @Input('amenityBuildingSelect') _amenityBuildingSelect = false;
    multiselectSettings = {
        singleSelection: false,
        text: 'Select',
        selectAllText: 'Select All',
        unSelectAllText: 'Deselect All',
        enableSearchFilter: true
    };

    constructor() { super(); }

    get data() { return this._data; }

    set data(val) {
        this._data = typeof val === 'string' ? val.trim() : val;
        this.propagateChange(this._data);
    }

    validator(value: any): boolean { return true; }

    apply(): void {
        if(!this._amenityBuildingSelect)
            super.apply();
        else {
            if(this._value.length > 0) {
                const ifDeletedBuildingsAreAvailable = this.checkIfDeletedBuildingsAreAvailable();
                const user = JSON.parse(localStorage.getItem('userData'));
                if(ifDeletedBuildingsAreAvailable && user.userType != 'super_admin') {
                    toastr.warning(this._accessError + ifDeletedBuildingsAreAvailable.slice(0, -2));
                } else
                    super.apply();
            } else
                toastr.warning(this._blankError);
        }
    }

    checkIfDeletedBuildingsAreAvailable(): string {
        let availableBuildingsForAmenityBuildingUpdate = [];
        JSON.parse(localStorage.getItem('userData')).buildingPropertyManager.forEach((manager) => {
            availableBuildingsForAmenityBuildingUpdate.push(manager.buildingId);
        });
        let newBuildings = '';
        if(JSON.parse(this.originValue).length != this.value.length) {
            JSON.parse(this.originValue).forEach((original) => {
                if(JSON.stringify(this.value).indexOf(JSON.stringify(original)) == -1) {
                    if(availableBuildingsForAmenityBuildingUpdate.indexOf(original.id) == -1)
                        newBuildings += original.itemName + ', ';
                }
            });
            this.value.filter((newValue) => {
                if(this.originValue.indexOf(JSON.stringify(newValue)) == -1) {
                    if(availableBuildingsForAmenityBuildingUpdate.indexOf(newValue.id) == -1)
                        newBuildings += newValue.itemName + ', ';
                }
            });
        }
        return newBuildings;
    }
}




// WEBPACK FOOTER //
// /app/src/app/components/fields/multiselect-field/multiselect-field.component.ts